import { HasProduct, withProduct } from "@insite/client-framework/Components/ProductContext";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import { ProductDetailsPageContext } from "@insite/content-library/Pages/ProductDetailsPage";
import ADIPdpTabs from "@NA/Components/ADIPdpTabs";
import updatePDPTab from "@NA/Handlers/ADIUpdatePDPtabs";
import * as React from "react";
import { ResolveThunks, connect } from "react-redux";
import CustomApplicationState from "@NA/Store/Data/CustomApplicationState/CustomApplicationState";

const mapStateToProps = (state: CustomApplicationState) => {
    return {
        activeTab: state.ADIGlobalData.updatePDPTab.currentActiveTab
    };
};

const mapDispatchToProps = {
    updatePDPTab
}

type Props = HasProduct & ReturnType<typeof mapStateToProps> & ResolveThunks<typeof mapDispatchToProps>;

const ADIPdpStickyTabs: React.FC<Props> = ({ activeTab, updatePDPTab, product }) => {
    const [tabs, showTabs] = React.useState({
        overViewTab: true,
        specificationTab: true,
        documentsTab: true
    })

    React.useEffect(()=> {
        updatePDPTab({updateTab: "OverviewTitle"})
    }, [])

    React.useEffect(()=> {
        showTabs({
            ...tabs,
            overViewTab: !product,
            specificationTab: !product.specifications || product.specifications.length === 0,
            documentsTab: !product.documents || product.documents.length === 0,
        });
    }, [product])

    return (
        <ADIPdpTabs 
            currentId="ButtonTabsPDP_page"
            tabsVisibility={tabs}
            currentActiveTab={activeTab}
        />
    )
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps,mapDispatchToProps)(withProduct(ADIPdpStickyTabs)),
    definition: {
        displayName: "ADIPdpStickyTabs",
        group: "Product Details",
        allowedContexts: [ProductDetailsPageContext],
    },
};

export default widgetModule;
